"use strict";

const PureRenderMixin = React.addons.PureRenderMixin;
const dealsAPI = require("app/util/api/deals");
const DealWonPopbox = require("app/shared/components/DealWonPopbox/deal-won-popbox");
const SignalActions = require("app/shared/actions/signal-actions");
const DatePicker = require("app/shared/components/DatePicker/date-picker");
const moment = require("moment");
const DEAL_STATUS_WON_ID = 2;

const DealWonPopboxContainer = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    dealId: React.PropTypes.number.isRequired,
    afterSaveCallback: React.PropTypes.func.isRequired,
    anchor: React.PropTypes.object.isRequired,
    isVisible: React.PropTypes.bool,
    onClose: React.PropTypes.func
  },

  getDefaultProps: function() {
    return {
      isVisible: true,
      onClose: () => {}
    };
  },

  getInitialState: function() {
    return {
      isPopboxVisible: this.props.isVisible,
      selectedDate: moment(new Date()).format(DatePicker.sysDateFormat)
    };
  },

  componentWillReceiveProps: function(nextProps) {
    this.setState({ isPopboxVisible: nextProps.isVisible });
  },

  handleRequestError: function(error) {
    let message = "Ocorreu um erro inesperado, se persistir entre em contato com o nosso suporte.";

    if (error) {
      if (error.customError) {
        message = error.message + ", tente novamente mais tarde.";
      } else if (error.status === 403) {
        message = "Você não possui privilégio para finalizar um negócio. Contate o administrador de sua conta para lhe conceder este privilégio em <a href='/sistema/grupos'>Grupos</a>.";
      }
    }

    this.showSignal(message, "warning");
  },

  showSignal: function(message, type) {
    SignalActions.show({
      message: message,
      type: type,
      hideTimeout: 5000
    });
  },

  handleDateChange: function(date) {
    this.setState({ selectedDate: moment(date).format(DatePicker.sysDateFormat) });
  },

  handleSave: function() {
    const wonAt = moment(this.state.selectedDate).format(DatePicker.sysDateFormat);

    const params = {
      "ends_at": wonAt,
      "deal_status": DEAL_STATUS_WON_ID
    };

    dealsAPI.statusUpdate(this.props.dealId,
      params,
      this.handleAfterSave,
      this.handleRequestError);
  },

  handleAfterSave: function() {
    const wonAt = moment(this.state.selectedDate).format("YYYY-MM-DD 00:00:00");

    this.props.afterSaveCallback(wonAt);
  },

  onPopboxClose: function() {
    this.setState({ isPopboxVisible: false });

    this.props.onClose();
  },

  render: function() {
    return (
      <DealWonPopbox
        onSave={this.handleSave}
        selectedDate={this.state.selectedDate}
        onDateChange={this.handleDateChange}
        anchor={this.props.anchor}
        onClose={this.onPopboxClose}
        isVisible={this.state.isPopboxVisible}
      />
    );
  }
});

module.exports = DealWonPopboxContainer;



// WEBPACK FOOTER //
// ./app/shared/components/DealWonPopbox/deal-won-popbox-container.jsx